export enum MessageType {
	Default = 0,
	Trace = 1,
	Debug = 2,
	Information = 3,
	Success = 4,
	Warning = 5,
	Error = 6,
	Fatal = 7
}

export interface IMessage {
	type?: MessageType;
	content: string;
	dismissable?: boolean;
}
